import React, { useCallback, useEffect, useState } from 'react'
import {
  Grid,
  Container,
  Card,
  CardContent,
  Typography,
  LinearProgress,
  Divider,
} from '@mui/joy'
import QRCode from 'react-qr-code'
import { TOTP } from 'totp-generator'
import { useGetStoreDataQuery } from '../services/branding'

function QR() {
  const { data: storeData, isLoading: isStoreDataLoading } =
    useGetStoreDataQuery()

  const TOTP_PERIOD = 30 * 1000
  const [totpSecret, setTotpSecret] = useState('')
  const [storeId, setStoreId] = useState('')

  const generateOtp = (): string => {
    const { otp } = TOTP.generate(totpSecret, {
      period: TOTP_PERIOD / 1000,
      timestamp: Date.now(),
    })
    return otp
  }

  const [totpCode, setTotpCode] = useState('')
  const [progress, setProgress] = useState(100)
  const [expirationTime, setExpirationTime] = useState(
    Math.ceil(Date.now() / TOTP_PERIOD) * TOTP_PERIOD,
  )

  useEffect(() => {
    if (storeData && !isStoreDataLoading) {
      setTotpSecret(storeData.totpSecret)
      setTotpCode(generateOtp())

    }
  }, [isStoreDataLoading, storeData, totpSecret])

  useEffect(() => {
    const progressInterval = setInterval(() => {
      const currentTime = Date.now()

      if (currentTime >= expirationTime) {
        setTotpCode(generateOtp())
        setExpirationTime(currentTime + TOTP_PERIOD)
        setProgress(100)
      } else {
        const elapsedInPeriod = currentTime % TOTP_PERIOD
        const timeRemaining = TOTP_PERIOD - elapsedInPeriod
        setProgress((timeRemaining / TOTP_PERIOD) * 100)
      }
    }, 200)

    return () => clearInterval(progressInterval)
  }, [expirationTime, TOTP_PERIOD, generateOtp])

  return (
    <>
      <Grid>
        <Container>
          <Typography level="h4" sx={{ mb: 2 }}>
            QR kód
          </Typography>
          <Divider />
        </Container>
      </Grid>
      <Container maxWidth="xs" sx={{ pt: 10 }}>
        <Grid
          container
          spacing={5}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Card>
            <CardContent>
              <QRCode
                value={`https://loyaltea-web-frontend.pages.dev/${storeId}?otp=${totpCode}`}
                size={200}
              />
              <LinearProgress
                determinate
                variant="outlined"
                color="neutral"
                size="sm"
                thickness={20}
                value={progress}
                sx={{
                  mt: 1,
                  '--LinearProgress-radius': '20px',
                  '--LinearProgress-progressThickness': '16px',
                  boxShadow: 'sm',
                  borderColor: 'neutral.500',
                }}
              />
              {totpCode}
            </CardContent>
          </Card>
        </Grid>
      </Container>
    </>
  )
}

export default QR
